import { render, staticRenderFns } from "./AccountPayableTax.vue?vue&type=template&id=c8fe65ea&scoped=true"
import script from "./AccountPayableTax.vue?vue&type=script&lang=js"
export * from "./AccountPayableTax.vue?vue&type=script&lang=js"
import style0 from "./AccountPayableTax.vue?vue&type=style&index=0&id=c8fe65ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fe65ea",
  null
  
)

export default component.exports